export const WEEKDAYS_WIDTHS = '3rem 3rem 3rem 3rem 3rem'
export const WEEKEND_WIDTH = '0.5rem'

export const TIMELINE_COL_WIDTH = '15rem'
